module.exports = __webpack_public_path__ + "img/T937.8ffd4032.jpg";